//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfInput from "../../atoms/SfInput/SfInput.vue";
import SfButton from "../../atoms/SfButton/SfButton.vue";

export default {
  name: "SfQuantitySelector",
  inject: {
    components: {
      default: {
        SfInput,
        SfButton,
      },
    },
  },
  model: {
    prop: "qty",
  },
  props: {
    qty: {
      type: [Number, String],
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    ariaLabel: {
      type: String,
      default: "Quantity",
    },
    ariaLabelMinus: {
      type: String,
      default: "Reduce quantity",
    },
    ariaLabelPlus: {
      type: String,
      default: "Increase quantity",
    },
  },
  KEYCODES: {
    BACKSPACE: 8,
    TAB: 9,
    SHIFT: 16,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    DELETE: 46,
    ZERO: 48,
    NUMPAD_ZERO: 96
  },
  handleInput(qty, listeners, min, max) {
    const minimum = min || 1;
    qty = Math.min(Math.max(qty, minimum), max);
    listeners.input?.(qty);
    return listeners.blur?.(qty);
  },
  handleKeyUp(event, listeners, min, max) {
    const value = Number(event.target.value);
    if (value > min && value <= max) {
      return listeners.input?.(value);
    } else if (value > max) {
      listeners.input?.(max);
      event.target.value = max;
      return event.preventDefault();
    }
  },
  handleNumberInput(value, valueStr, listeners, min, max, keycodes, isEnter, event) {
    const selectedValue = document.getSelection().toString();
    const selectionStart = valueStr.indexOf(selectedValue);
    const selectionEnd = selectionStart > -1 ? selectionStart + selectedValue.length : selectionStart;
    const newValue = selectionStart == selectionEnd ? value * 10 + Number(event.key) : Number(valueStr.substring(0, selectionStart) + event.key + valueStr.substring(selectionEnd));

    if(isEnter) {
      return listeners.blur?.(value || min);
    }

    if(value > max) {
      return event.preventDefault()
    };

    //keyCodes between 48 and 57 are numbers and between 96 and 105 are numpad numbers
    if(
      ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) &&
      value !== 0
    ) {
      if(newValue > max) {
        value = max;
      } else if(newValue < min) {
        value = min;
      }

      listeners.input?.(value);

      if(newValue > max) {
        listeners.error?.('maxQtyReached')

        return event.preventDefault()
      };
      if(newValue < min) {
        listeners.error?.('minQtyReached')

        return event.preventDefault()
      };
      return;
    }
    if(isNaN(event.key) || keycodes.ZERO === event.keyCode || keycodes.NUMPAD_ZERO === event.keyCode){
      return event.preventDefault();
    }
  },
  handleKeyDown(event, listeners, min, max, keycodes, isEnter = false) {
    const valueStr = event.target.value;
    const value = Number(valueStr);

    switch(event.keyCode) {
      case keycodes.ARROW_UP:
        return this.handleArrowUpDown(value + 1, listeners, min, max, event);
      case keycodes.ARROW_DOWN:
        return this.handleArrowUpDown(value - 1, listeners, min, max, event);
      case keycodes.BACKSPACE:
      return this.handleArrowUpDown(value, listeners, min, max, event);
      case keycodes.ARROW_LEFT:
      case keycodes.ARROW_RIGHT:
      case keycodes.SHIFT:
      case keycodes.TAB:
      case keycodes.DELETE:
        return true;
      default:
        this.handleNumberInput(value, valueStr, listeners, min, max, keycodes, isEnter, event);
    }
  },
  handleBlur(event, listeners, min, max) {
    let value = Number(event.target.value);

    if (value > max) {
      value = max;
    } else if (value < min || value === 0) {
      value = min;
    }

    listeners.input?.(value);
    return listeners.blur?.(value);
  },
  handleArrowUpDown(newValue, listeners, min, max, event) {
    newValue = Math.min(Math.max(newValue, min), max);
    listeners.input?.(newValue);
    event.preventDefault();
  },
  uniqueKey() {
    const key = Math.random().toString(16).slice(2);
    return `quantitySelector${key}`;
  },
};
